import Button from '@/common/components/Button'
import Modal from '@/common/components/Modal'
import { ErrorResponse } from '@/common/types/errorResponse'
import { handleServerError } from '@/common/utils/handleServerError'
import { useReviewPriceSurvey } from '@/features/privateCompanies/hooks/priceSurvey/useReviewPriceSurvey'
import { RejectPriceSurveyValidationSchema } from '@/features/privateCompanies/schemas/priceSurvey/reject.schema'
import { useQueryClient } from '@tanstack/react-query'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

interface ApprovePriceSurveyModalProps {
  disabled?: boolean
}

export const ApprovePriceSurveyModal = ({ disabled }: ApprovePriceSurveyModalProps) => {
  const { id } = useParams()
  const queryClient = useQueryClient()

  const [isOpen, setIsOpen] = useState(false)
  const [baseError, setBaseError] = useState('')

  const onSuccess = () => {
    queryClient.invalidateQueries({ queryKey: ['companyPriceSurveys'] })
    queryClient.invalidateQueries({ queryKey: ['companyPriceSurvey', id] })
    setIsOpen(false)
  }

  const onError = (error: ErrorResponse) => {
    handleServerError({ error, setBaseError })
  }

  const { mutate: approvePriceSurvey, isPending: approvePriceSurveyIsPending } = useReviewPriceSurvey({
    priceSurveyId: id,
    review: 'approve',
    onSuccess,
    onError,
  })

  const onSubmit = () => {
    setBaseError('')
    approvePriceSurvey({} as RejectPriceSurveyValidationSchema)
  }

  return (
    <Modal
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      onConfirm={onSubmit}
      Trigger={
        <Button
          type="button"
          className="w-[10.25rem]"
          disabled={disabled}
          operationKlassToCheckPermission="Admin::Client::PriceSurveys::Approve"
        >
          Aprovar
        </Button>
      }
      triggerDisabled={disabled}
      useCancellableFooter
      confirmButtonClassName="bg-blue-700"
      disabled={approvePriceSurveyIsPending}
      title="Você tem certeza?"
      titleClass="text-2xl font-bold mb-2"
      subtitle="Essa pesquisa de preço será aprovada."
      body={baseError ? <p className="text-sm text-danger-soft">{baseError}</p> : undefined}
    />
  )
}
